module.exports = __webpack_public_path__ + "img/availability.52bc4be7.jpg";